/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of the research prompt
 * @export
 */
export const ResearchPromptStatus = {
    Pending: 'pending',
    Streaming: 'streaming',
    Complete: 'complete'
} as const;
export type ResearchPromptStatus = typeof ResearchPromptStatus[keyof typeof ResearchPromptStatus];


export function instanceOfResearchPromptStatus(value: any): boolean {
    for (const key in ResearchPromptStatus) {
        if (Object.prototype.hasOwnProperty.call(ResearchPromptStatus, key)) {
            if (ResearchPromptStatus[key as keyof typeof ResearchPromptStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ResearchPromptStatusFromJSON(json: any): ResearchPromptStatus {
    return ResearchPromptStatusFromJSONTyped(json, false);
}

export function ResearchPromptStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResearchPromptStatus {
    return json as ResearchPromptStatus;
}

export function ResearchPromptStatusToJSON(value?: ResearchPromptStatus | null): any {
    return value as any;
}

export function ResearchPromptStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ResearchPromptStatus {
    return value as ResearchPromptStatus;
}

